// Generated by Melange

import * as Buhta_cabinet__Btn from "../../../components/html/Btn.js";
import * as Buhta_cabinet__ControlAdmin from "../../../grpc/ControlAdmin.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__Field from "../../../components/html/Field.js";
import * as Buhta_cabinet__PhoneField from "../../../components/html/PhoneField.js";
import * as Buhta_cabinet__ToastSender from "../../../util/ToastSender.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Tenant from "../../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../../packages/core/lib/Toast.js";
import * as Curry from "melange.js/curry.js";
import * as Formating from "../../../../../../packages/util/lib/Formating.js";
import * as $$Promise from "../../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function IdentityCreatePage(Props) {
  let onItemCreated = Props.onItemCreated;
  const match = React.useState(function () {
    return "";
  });
  const setPhone = match[1];
  const phone = match[0];
  const match$1 = React.useState(function () {
    return "";
  });
  const setName = match$1[1];
  const name = match$1[0];
  const match$2 = React.useState(function () {
    return "";
  });
  const setLastName = match$2[1];
  const lastName = match$2[0];
  const match$3 = React.useState(function () {
    return "";
  });
  const setEmail = match$3[1];
  const email = match$3[0];
  const match$4 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const dispatchToasts = match$4[1];
  const match$5 = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match$5[0];
  const header = null;
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
      header: header,
      children: JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                    className: "w-20 h-20",
                    src: StaticAsset.src("/static/icons/avatar-black.svg")
                  }),
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("img", {
                      src: StaticAsset.src("/static/icons/image-new-white-16.svg")
                    }),
                    className: "bg-black/40 absolute bottom-0 w-full flex justify-center py-1"
                  })
                ],
                className: "relative rounded-full w-20 overflow-hidden"
              }),
              className: " flex gap-6 items-center"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                  label: "Имя",
                  type_: "text",
                  onChange: (function (value) {
                    Curry._1(setName, (function (param) {
                      return value;
                    }));
                  }),
                  className: "w-full",
                  value: name
                }),
                JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                  label: "Фамилия",
                  type_: "text",
                  onChange: (function (value) {
                    Curry._1(setLastName, (function (param) {
                      return value;
                    }));
                  }),
                  className: "w-full",
                  value: lastName
                })
              ],
              className: "mt-6 flex gap-4"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Buhta_cabinet__PhoneField.make, {
                  value: Formating.formatPhone(phone),
                  onChange: (function (value) {
                    Curry._1(setPhone, (function (param) {
                      return value;
                    }));
                  })
                }),
                JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                  className: "absolute -top-1.5 left-2 bg-white px-2 text-gray-medium",
                  children: "Телефон"
                })
              ],
              className: "mt-6 relative"
            }),
            JsxRuntime.jsx(Buhta_cabinet__Field.make, {
              label: "Email",
              type_: "email",
              onChange: (function (value) {
                Curry._1(setEmail, (function (param) {
                  return value;
                }));
              }),
              autoComplete: "off",
              className: "mt-6",
              value: email
            }),
            JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
              title: "Сохранить",
              onClick: (function (param) {
                const updateData = {
                  family_name: lastName,
                  given_name: name,
                  email: email,
                  phone: phone,
                  userpic_id: undefined,
                  password: undefined
                };
                const __x = Buhta_cabinet__ControlAdmin.AdminIdentityService.create(tenant, updateData);
                $$Promise.get(__x, (function (result) {
                  if (result.TAG !== /* Ok */ 0) {
                    return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при создании пользователя");
                  }
                  Curry._1(onItemCreated, result._0.id);
                  Curry._1(dispatchToasts, {
                    TAG: /* Add */ 0,
                    _0: {
                      id: Buhta_core__Toast.generateId(undefined),
                      text: "Пользователь успешно создан",
                      kind: "success",
                      onClick: (function (param) {
                        
                      })
                    }
                  });
                }));
              }),
              className: "mt-4 w-full py-3"
            })
          ],
          className: "bg-white w-140.5 p-10 mt-6 rounded-sm shadow-card"
        }),
        className: "w-full flex flex-col items-center"
      }),
      className: "bg-gray-pale"
    }),
    className: "overflow-auto"
  });
}

const make = IdentityCreatePage;

export {
  make,
}
/* Buhta_cabinet__Btn Not a pure module */
